import React, { Component, Fragment } from 'react';
import SashiDo from 'lib/SashiDo';

import { yearMonthDayFormatter } from 'lib/DateUtils';
import AppsManager from 'lib/AppsManager';
import LoaderDots from 'components/LoaderDots/LoaderDots.react';
import ProgressBar from 'components/ProgressBar/ProgressBar.react';
import Icon from 'components/Icon/Icon.react';
import history from 'dashboard/history';
import prettyNumber from 'lib/prettyNumber';
import styles from 'dashboard/Apps/AppsIndex.scss';
import { getRegion, findParseServerVersion } from 'lib/Constants';


const dash = (value, content) => {
  if (value === undefined) {
    return '-';
  }
  if (content === undefined) {
    return value;
  }
  return content;
};

const MetricsInfo = ({ app }) => {
  const { users, installations } = app;

  if (app.users === undefined || app.installations === undefined) {
    return (
      <div className={styles.extraInfoHolder} style={{ justifyContent: 'center', alignItems: 'center' }}>
        <div className={styles.smallLoaderDots}><LoaderDots /></div>
      </div>
    );
  }

  return (
    <div className={styles.extraInfoHolder}>
      <div className={styles.extraInfoCol}>
        <div className={styles.extraInfoRow}>
          <div className={styles.infoTitle}>users</div>
          <div className={styles.infoValue}>{dash(users, prettyNumber(users))}</div>
        </div>
        <div className={styles.extraInfoRow}>
          <div className={styles.infoTitle}>installations</div>
          <div className={styles.infoValue}>{dash(installations, prettyNumber(installations))}</div>
        </div>
      </div>
    </div>
  );
};


const ExtraInfo = ({ app }) => {
  const { params, region } = app;
  const { highly_available, engine } = params.settings;
  const engineName = (engine[region] || {}).name;
  const { auto, min, max } = params.deployment.replicas;

  const autoText = auto ? 'On' : 'Off';
  const highlyAvailableText = highly_available ? 'On' : 'Off';

  const onClickHandler = (e) => {
    e.stopPropagation();

    if (!app.params.payment_needed) {
      history.push(`/products/apps/${app.slug}/runtime/engine`);
    }
  };

  return (
    <div className={[styles.extraInfoHolder, styles.interactive].join(' ')} onClick={onClickHandler}>
      <div className={styles.extraInfoEngineType}>
        {engineName}
        <Icon name="icon-cog" width={12} height={12} fill="#fff" />
      </div>
      <div className={styles.extraInfoCol}>
        <div className={styles.extraInfoRow}>
          <div className={styles.infoTitle}>Auto-Scaling</div>
          <div className={[styles.extraInfoIndicator, styles[autoText]].join(' ')}>
            {autoText}
          </div>
        </div>
        <div className={styles.extraInfoRow}>
          <div className={styles.infoTitle}>High Availability</div>
          <div className={[styles.extraInfoIndicator, styles[highlyAvailableText]].join(' ')}>
            {highlyAvailableText}
          </div>
        </div>
      </div>

      <div className={styles.extraInfoCol}>
        <div className={styles.extraInfoRow}>
          <div className={styles.infoTitle}>Min. Engines</div>
          <div className={styles.infoValue}>{min}</div>
        </div>
        <div className={styles.extraInfoRow}>
          <div className={styles.infoTitle}>Max. Engines</div>
          <div className={styles.infoValue}>{max}</div>
        </div>
      </div>
    </div>
  );
};

class AppRow extends Component {
  constructor(props) {
    super(props);

    const { app } = props;
    this.state = {
      app,
    };
  }

  async componentDidMount() {
    const { app } = this.props;
    const { installations, users } = app;

    if (!installations || !users) {
      const currentApp = await AppsManager.getAppClassesClount(app);
      this.setState({ app: currentApp });
    }
  }

  render() {
    const { app } = this.state;
    if (!app) return null;

    // We should remove 'migration_status' someday
    // But we need to update all records in database where migration_status exist with server_status
    const complete = ((app.server_status && app.server_status.state === 'finished') || (app.migration_status && app.migration_status.state === 'finished'));

    let path = complete ? '/browser' : '/creation';

    if (!app.serviceName) {
      path = '/creation';
    }

    const canBrowse = (p) => {
      if (!app.params.payment_needed) {
        document.body.classList.remove('open');
        history.push(`/products/apps/${app.slug}${p}`);
      }
    };


    let stats;

    if (app.serviceName) {
      if (app.params.payment_needed) {
        stats = null;
      } else if (app.params.restoring_backup) {
        stats = (
          <div className={styles.restoringStatus}>
            <span>Restoring Database</span>
            <LoaderDots />
          </div>
        );

        const reload_int = setInterval(() => {
          app.reload().then((currentApp) => {
            const appReloaded = AppsManager.appsStoreUpdateApp(currentApp);

            if (!appReloaded.params.restoring_backup) {
              this.forceUpdate();
              clearInterval(reload_int);
            }
          });
        }, 15000);
      } else if (complete) {
        stats = (
          <Fragment>
            <ExtraInfo app={app} />
            <MetricsInfo app={app} />
          </Fragment>
        );
      } else {
        stats = (
          <div className={styles.migrationStatus}>
            <span>Creation Progress</span>
            <ProgressBar percent={80} />
          </div>
        );
      }
    } else {
      stats = (
        <div className={styles.migrationStatus}>
          <span>Creation Progress</span>
          <ProgressBar percent={80} />
        </div>
      );
    }

    return (
      <li onClick={() => canBrowse(path)} key={app.id} className={app.params.payment_needed ? styles.payment_needed : null}>
        <span className={styles.icon}>
          <img src={app.icon ? app.icon : '/assets/images/default_app_icon.png'} alt={app.name} />
        </span>
        <div className={styles.details}>
          <div className={styles.createdAt}>{yearMonthDayFormatter(app.createdAt)}</div>
          <h3>
            <span>
              {app.name}
            </span>
            {
              // app.params.payment_needed
              //   ? <span className={styles.delete} onClick={() => this.setState({ showDeleteAppModal: true, appNameToDelete: app })}>Delete Application</span>
              //   : null
            }
          </h3>
          <div className={styles.info}>
            <span>{getRegion[app.region].value}</span>
            {
              app.parseServerVersion &&
                <Fragment>
                  <div className={styles.separator}>&middot;</div>
                  <div className={styles.serverVersion}>Parse Server v{findParseServerVersion(app.parseServerVersion).version}</div>
                </Fragment>
            }
            {app.params.payment_needed ? <div className={styles.payment_needed_text}>Payment Needed</div> : null}
          </div>
          {/* <ExtraInfo app={app} /> */}
        </div>

        {stats}
      </li>
    );
  }
}

export default AppRow;
